import {
  DscSpendTracker,
  LoyaltyMemberAnnualBalance,
  LoyaltyMemberProgramBalance,
  LoyaltyMemberTierLevel,
  MedallionStatus,
  PersonName
} from './tracker-details.interfaces';

export interface StatusTrackerResponse {
  loyaltyMemberId: string;
  carrierCode: string;
  countryCode: string;
  personName: PersonName;
  enrolledInPromotionalStatus: boolean;
  promotionalStatusCode?: string;
  promotionalStatusDesc?: string;
  hasFutureFlights: boolean;
  futureFlightCnt: number;
  loyaltyMemberAnnualBalances: LoyaltyMemberAnnualBalance[];
  loyaltyMemberProgramBalance: LoyaltyMemberProgramBalance;
  loyaltyMemberTierLevels: LoyaltyMemberTierLevel[];
  futureLoyaltyMemberMedallionStatus?: MedallionStatus[];
  currentLoyaltyMemberMedallionStatus: MedallionStatus[];
  previousLoyaltyMemberMedallionStatus?: MedallionStatus[];
  previousMinus1LoyaltyMemberMedallionStatus?: MedallionStatus[];
  dscSpendTracker?: DscSpendTracker[];
}

export interface PayloadRequest {
  carrierCode: string;
}

export interface CommonRequest extends PayloadRequest {
  retry: number;
  timeout: number;
}
